export function postProcessQuery(
  requestBody: any,
  requestState: any,
  queryConfig: any,
  toggleChecked: boolean // toggleChecked is false when the user wants to match any of the words (a.k.a. "Match Any" / OR)
) {
  // If there is no search term, return the requestBody as is
  // The connector will generate a query that doesn't include anything that needs to be post-processed, e.g., no multi_match queries
  if (!requestState.searchTerm) return requestBody;

  if ("bool" in requestBody.query) {
    if ("should" in requestBody.query.bool) {
      // Change the should array to must
      requestBody.query.bool.must = requestBody.query.bool.should;
      // Remove the should array
      delete requestBody.query.bool.should;
    }
    // Filter out the multi_match queries we want to remove and modify the ones we want to keep
    requestBody.query.bool.must = requestBody.query.bool.must?.filter(
      (mustQuery: any) => {
        // If it's a phrase or phrase_prefix query, filter it out
        // These are auto-generated by the connector and are not needed because we aren't supporting words required in a sequence.
        if (
          mustQuery.multi_match?.type === "phrase" ||
          mustQuery.multi_match?.type === "phrase_prefix"
        ) {
          return false; // This will remove the query from the array
        }
        // only for best_fields uses an operator
        // toggleChecked is false when the user wants to match any of the words (a.k.a. "Match Any" / OR)
        if (!toggleChecked && mustQuery.multi_match?.type === "best_fields") {
          mustQuery.multi_match.operator = "or";
        }
        return true; // Keep this query in the array
      }
    );
  }

  return requestBody;
}
